interface ReviewerSchema {
    type: 'array';
    minItems: number;
    maxItems: number;
    allOf?: {
        // type: 'object';
        contains: {
            type: 'object';
            properties: {
                query: {
                    type: 'string';
                    pattern: string;
                };
            };
        };
    }[];
}

export interface AdminConsentPolicySchema {
    // create another interface
    type: 'object';
    properties: {
        isEnabled: {
            type: 'boolean';
            const: boolean;
        };

        notifyReviewers?: {
            type: 'boolean';
            const: boolean;
        };

        remindersEnabled?: {
            type: 'boolean';
            const: boolean;
        };
        requestDurationInDays?: {
            type: 'number';
            const: number;
        };

        reviewers?: ReviewerSchema;
    };
}

export interface AdminConsentPolicyForm {
    isEnabled: boolean;
    notifyReviewers: boolean;
    remindersEnabled: boolean;
    requestDurationInDays: number;
    includeUsers: string[];
    includeGroups: string[];
    includeRoles: string[];
}

export function generateAdminConsentPolicySchema(form: AdminConsentPolicyForm): AdminConsentPolicySchema {
    if (!form.isEnabled) {
        return {
            type: 'object',
            properties: {
                // miss some props
                isEnabled: {
                    type: 'boolean',
                    const: form.isEnabled,
                },
            },
        };
    }

    const schema: AdminConsentPolicySchema = {
        type: 'object',
        properties: {
            // miss some props
            isEnabled: {
                type: 'boolean',
                const: form.isEnabled,
            },
            notifyReviewers: {
                type: 'boolean',
                const: form.notifyReviewers,
            },
            remindersEnabled: {
                type: 'boolean',
                const: form.remindersEnabled,
            },
            requestDurationInDays: {
                type: 'number',
                const: form.requestDurationInDays,
            },
        },
    };
    const reviewers: ReviewerSchema = {
        type: 'array',
        allOf: [],
        minItems: 0,
        maxItems: 0,
    };

    form.includeUsers?.forEach((userId) => {
        reviewers.allOf.push({
            // type: 'object',
            contains: {
                type: 'object',
                properties: {
                    query: {
                        type: 'string',
                        pattern: 'users/' + userId,
                    },
                },
            },
        });
    });

    form.includeGroups?.forEach((groupId) => {
        reviewers.allOf.push({
            // type: 'object',
            contains: {
                type: 'object',
                properties: {
                    query: {
                        type: 'string',
                        pattern: 'groups/' + groupId,
                    },
                },
            },
        });
    });

    form.includeRoles?.forEach((roleId) => {
        reviewers.allOf.push({
            // type: 'object',
            contains: {
                type: 'object',
                properties: {
                    query: {
                        type: 'string',
                        pattern: roleId,
                    },
                },
            },
        });
    });

    if (reviewers.allOf.length > 0) {
        reviewers.minItems = reviewers.allOf.length;
        reviewers.maxItems = reviewers.allOf.length;
        schema.properties.reviewers = reviewers;
    } else {
        schema.properties.reviewers = {
            type: 'array',
            minItems: 0,
            maxItems: 0,
        };
    }

    return schema;
}
